module.exports = __webpack_public_path__ + "static/media/copy.70ebff9e.svg";